import { sellerRouteFactory } from 'sh-www/routes/postings/index';
import { SELLER_POSTINGS_FIND_WORK_TAB_NAMES } from 'sh-www/constants/routes/postings';

/** @module */
export default sellerRouteFactory('postings/find-work/other', SELLER_POSTINGS_FIND_WORK_TAB_NAMES.OTHER);
